import React from 'react';
import { Grid, Card, CardContent, Typography, CircularProgress } from '@material-ui/core';
import { useSwaggerClient } from '../../../../hooks/useSwaggerClient';

const KPICard = ({ title, value, subtitle, loading }) => (
    <Grid item xs={12} sm={6} md={3}>
        <Card style={{ height: '100%' }}>
            <CardContent>
                <Typography color="textSecondary" gutterBottom variant="subtitle2">
                    {title}
                </Typography>
                {loading ? (
                    <CircularProgress size={24} />
                ) : (
                    <>
                        <Typography
                            variant="h4"
                            component="h2"
                            style={{ fontWeight: 'bold', marginBottom: '8px' }}
                        >
                            {value}
                        </Typography>
                        {subtitle && (
                            <Typography color="textSecondary" variant="body2">
                                {subtitle}
                            </Typography>
                        )}
                    </>
                )}
            </CardContent>
        </Card>
    </Grid>
);

const KPICards = ({ agentId, fromDate, toDate, dateType, status }) => {
    const [dashboardData, loading] = useSwaggerClient(
        'users/statistics',
        'getAgentActivityDashboard',
        {
            agentId,
            fromDate,
            toDate,
            dateType,
            status
        },
        [agentId, fromDate, toDate, dateType, status]
    );

    const kpis = dashboardData?.kpis || {};

    return (
        <>
            <KPICard
                title="Total Commission"
                value={`$${kpis.totalCommission || '0.00'}`}
                subtitle={`${kpis.totalVouchers || 0} vouchers`}
                loading={loading}
            />
            <KPICard
                title="Confirmed"
                value={`$${kpis.confirmedPastCommission || '0.00'}`}
                subtitle={`${kpis.confirmedPastVouchers || 0} vouchers`}
                loading={loading}
            />
            <KPICard
                title="Future (Confirmed)"
                value={`$${kpis.confirmedFutureCommission || '0.00'}`}
                subtitle={`${kpis.confirmedFutureVouchers || 0} vouchers`}
                loading={loading}
            />
            <KPICard
                title="Unconfirmed"
                value={kpis.unconfirmedVouchers || 0}
                subtitle="Needs follow-up"
                loading={loading}
            />
        </>
    );
};

export default KPICards;
